// 老师端- 场馆类型
import services from '../assets/js/services'

export default {
  state: {
  },
  getters: {
  },
  actions: {
    // 获取场馆类型列表
    getStadiumType (context, payload) {
      return services.getStadiumType(payload).then(res => {
        return res;
      })
    },
    // 场馆类型添加
    addStadiumType (context, payload) {
      return services.addStadiumType(payload).then(res => {
        return res;
      })
    },
    //  场馆类型编辑、删除
    editStadiumType (context, payload) {
      return services.editStadiumType(payload).then(res => {
        return res;
      })
    },
    //  场馆类型详情
    getStadiumTypeInfo (context, payload) {
      return services.getStadiumTypeInfo(payload).then(res => {
        return res;
      })
    },
  },
  mutations: {
  }
}